<template>
	<div class="transaction-request">
		<Accordion
			title="Transaction Request"
			v-model="showRequestTransaction"
			v-log="{
				event: 'open',
				target: 'TransactionAudit.RequestViewed',
				eventData: {
					...auditInfo,
					action: 'Viewed',
					target: 'Request'
				}
			}"
		>
			<template #body-content>
				<div class="transaction-request__container">
					<div class="transaction-request__header-actions">
						<ButtonGroup>
							<template slot="container">
								<Button
									className="btn--has-icon btn--small"
									labelText="Download"
									:btnClick="downloadFile"
									:iconClassName="'icon icon-download'"
									:iconBeforeLabel="true"
									:disabled="showButton"
									v-log="{
										event: 'click',
										target:
											'TransactionAudit.RequestDownload',
										eventData: {
											...auditInfo,
											action: 'Downloaded',
											target: 'Request'
										}
									}"
								></Button>
								<Button
									className="btn--has-icon btn--small"
									labelText="Copy"
									:btnClick="copyRequestTransaction"
									:iconClassName="'icon icon-copy'"
									:iconBeforeLabel="true"
									:disabled="showButton"
									v-log="{
										event: 'click',
										target:
											'TransactionAudit.RequestCopied',
										eventData: {
											...auditInfo,
											action: 'Copied',
											target: 'Request'
										}
									}"
								></Button>
							</template>
						</ButtonGroup>
					</div>
					<div class="transaction-request__details">
						<Spinner :processor="{ loading: loadingRequest }" />
						<pre>{{ formatToXML(requestTransaction) }}</pre>
					</div>
				</div>
			</template>
		</Accordion>
	</div>
</template>

<script>
import Accordion from '@/components/shells/accordion/accordion';
import ButtonGroup from '@/components/forms/button/button-group';
import Button from '@/components/forms/button/button';
import { copyToClipboard } from '@/utils/function';
import { LoggingMixin } from 'vue-ui-layout';
import ResponseRequestTransaction from '@/sections/transactions/mixins/responseRequestTransaction.js';
import Spinner from '@/components/visual/spinner/spinner';
import store from '@/store';
import _ from 'lodash';

export default {
	name: 'GlobalTransactionsDetailsRequest',
	mixins: [LoggingMixin, ResponseRequestTransaction],
	components: {
		Accordion,
		ButtonGroup,
		Button,
		Spinner
	},
	props: {
		requestBlob: {
			type: String,
			default: ''
		},
		auditInfo: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			showRequestTransaction: false,
			requestTransaction: '',
			loadingRequest: false
		};
	},
	computed: {
		showButton() {
			return _.isEmpty(this.requestBlob);
		}
	},
	methods: {
		async downloadFile() {
			if (this.requestBlob) {
				const requestJson = JSON.parse(this.requestBlob);

				if (!this.requestTransaction) {
					this.requestTransaction = await this.showTransactionRequest(
						requestJson.Uri
					);
				}
				const fileName = !requestJson.Name?.endsWith('.xml')
					? `${requestJson.Name}.xml`
					: requestJson.Name;
				this.downloadXMLTransaction(fileName, this.requestTransaction);
			}
		},
		copyRequestTransaction() {
			if (this.requestTransaction) {
				copyToClipboard(this.requestTransaction);

				return store.dispatch('toastMessages/push', {
					statusCode: 200,
					message: 'Transaction Request copied to clipboard!!'
				});
			}
		}
	},
	watch: {
		showRequestTransaction: {
			deep: true,
			async handler(val) {
				if (val && !this.requestTransaction) {
					const request =
						this.requestBlob && JSON.parse(this.requestBlob);
					if (request.Uri) {
						this.loadingRequest = true;
						this.requestTransaction = await this.showTransactionRequest(
							request.Uri
						);
						this.loadingRequest = false;
					}
				}
			}
		}
	}
};
</script>

<style lang="scss">
/**
  * Transaction Details - Transaction Request
  * Can use SCSS variables = TRUE
**/

.transaction-request {
	&__header-actions {
		display: flex;
		justify-content: flex-end;
		padding: $padding-md;
		border-bottom: 1px solid $neutral-2;

		@include mq($from: sm-l) {
			padding: $padding-md $padding-lg;
		}
	}

	&__details {
		padding: $padding-md;
		overflow: auto;
		max-height: 180px;
		@include scrollbar;
		font-size: $default-font-size - 4;
	}
}
</style>
